import { create } from 'zustand';
import { nanoid } from 'nanoid';

export type DebugMessageType = 'error' | 'warning' | 'info' | 'success';

interface DebugMessage {
  id: string;
  type: DebugMessageType;
  message: string;
  timestamp: Date;
  details?: any;
}

interface DebugStore {
  messages: DebugMessage[];
  addMessage: (type: DebugMessageType, message: string, details?: any) => void;
  clearMessages: () => void;
}

export const useDebugStore = create<DebugStore>((set) => ({
  messages: [],
  addMessage: (type, message, details) =>
    set((state) => ({
      messages: [
        {
          id: nanoid(),
          type,
          message,
          timestamp: new Date(),
          details,
        },
        ...state.messages,
      ].slice(0, 100), // Keep last 100 messages
    })),
  clearMessages: () => set({ messages: [] }),
}));